import "./ToolTip.scss"

import React, { ReactElement } from "react"
import classNames from "classnames"

interface Props {
  content: string
  direction?: string
}
export default function ToolTip({
  direction,
  content,
  children,
}: React.PropsWithChildren<Props>): ReactElement {
  return (
    <div className={classNames("toolTip", direction)}>
      {children}
      <div className="tooltipText">{content}</div>
    </div>
  )
}
